const dielinesRoot = document.getElementById("rt-dl-page-container");

if (dielinesRoot && dielinesRoot instanceof HTMLDivElement) {
	void import("./dielines/layout.js").then((e) => {
		e.mountDielines(dielinesRoot);
	});
}

const whatSizeRoot = document.getElementById("dielines-what-size");

if (whatSizeRoot && whatSizeRoot instanceof HTMLDivElement) {
	void import("./what-size/layout.js").then((e) => {
		e.mountWhatSize(whatSizeRoot);
	});
}
